(ns ycweb.app.website.cart.pages.details-newsletter
  (:require
   [rum.core :as rum]

   [ycweb.app.website.cart.parts.common :as cart.common]
   [ycweb.components.common :as cmn]
   [ycweb.components.forms :as forms]
   [ycweb.components.buttons :as buttons]))

(rum/defc newsletter-form < rum/reactive cmn/cursors [app-atom process-atom cart-atom]
  "Newsletter form - matches step-07.html"
  (let [signups-atom (rum/cursor process-atom [:signups])
        cart-summary-atom (rum/cursor-in app-atom [:cart-summary])
        newsletter-atom (rum/cursor signups-atom :newslettersubscribe)
        promotions-atom (rum/cursor signups-atom :promotionsubscribe)

        newsletter-on? (rum/react newsletter-atom)

        skip-target-info (get cart.common/step-def (cart.common/skip-step-key process-atom cart-atom))
        skip-leads-to-checkout?
        (and
          (contains? (:properties skip-target-info) :checked-out)
          (not (contains? (:properties (cart.common/current-step-info process-atom)) :checked-out)))
        continue-fn
        (fn []
          (swap! cart-summary-atom
            (fn [cart-summary]
              (update-in cart-summary [:cart :options :subscribe]
                (fn [_]
                  {:newsletter (:newslettersubscribe @signups-atom)
                   :promotions (:promotionsubscribe @signups-atom)
                   :jobs (:jobsubscribe @signups-atom)
                   :surveys (:surveysubscribe @signups-atom)})))))]

    (cart.common/checkout-layout process-atom true
      (list
        [:h2 {:key "newsletter-heading" :class "yc-heading yc-heading--default"}
         "Would you like to receive our newsletters and personalised offers?"]

        (rum/with-key
          (forms/toggle "Newsletters and personalised offers"
            newsletter-atom
            {:description "Find out first about new launches and deals, plus the chance to receive occasional vouchers"
             :id "newsletter-signup"
             :name "newsletter-signup"
             :form-field? true
             :on-change
             (fn [_]
               (let [new-val (not @newsletter-atom)]
                 (reset! newsletter-atom new-val)
                 (when new-val
                   (reset! promotions-atom true))))})
          "newsletter-toggle")

        (rum/with-key
          (forms/toggle "Personalised offers only"
            promotions-atom
            {:description "Sign up for the chance of occasional personalised vouchers, without getting our newsletters"
             :id "personalised-offers"
             :name "personalised-offers"
             :form-field? true
             :disabled newsletter-on?})
          "promotions-toggle")

        [:p {:key "newsletter-note" :class "yc-paragraph"}
         "We won't share your details with anyone, and you can update your preferences or unsubscribe at any time."]

        (when-not skip-leads-to-checkout?
          [:div {:key "skip-button"}
           (buttons/button-web "Skip this step"
             {:on-click #(cart.common/skip-step app-atom process-atom cart-summary-atom nil %)
              :style :secondary
              :icon-placement :right
              :class "button--has-icon-right"
              :icon :arrow-right})]))

      (cart.common/checkout-cta-sidebar app-atom process-atom cart-atom
        {:continue-fn continue-fn}))))

(defmethod cart.common/checkout-step :details/newsletter
  [app-atom process-atom cart-atom]
  (newsletter-form app-atom process-atom cart-atom))